import instance from './instance';
import TokenStrategyFactory from '../../../auth/tokenStrategies/tokenStrategyFactory';

const jwtToken = () => TokenStrategyFactory.getTokenStrategy('jwt').getToken();

const configRequest = () => ({
  headers: {
    Authorization: `Bearer ${jwtToken()}`,
    Accept: 'application/json',
  },
});

export default class EditorAPI {
  constructor(config = {}) {
    this.path = config.path;

    this.axios = instance();
  }

  get(resource = '', config = {}) {
    return this.axios.get(`${this.path}/${resource}`, Object.assign({}, configRequest(), config));
  }
}



// WEBPACK FOOTER //
// ./src/services/request/editorApi/index.js